import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useMediaQuery,
} from "@chakra-ui/react";
//@ts-ignore
import dateFormat from "dateformat";
//@ts-ignore
import * as React from "react";
import { useLocation } from "react-router-dom";
import { LoginActivity } from "types/apiTypes";
import { UAParser } from "ua-parser-js";

interface Props {
  LoginActivity: LoginActivity[] | undefined;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
}
interface countTable {
  browser: UAParser.IBrowser;
  cpu: UAParser.ICPU;
  device: UAParser.IDevice;
  count: Number;
}
const LoginActivityModal: React.FC<Props> = ({
  setOpenModal,
  LoginActivity,
  openModal,
}) => {
  const { pathname } = useLocation();
  const [isLargerThanMd] = useMediaQuery("(min-width: 48em)");
  let uniqueDevices = new Map();
  let uniqueDevicesArray: countTable[] = [];
  if (LoginActivity && LoginActivity.length > 0) {
    LoginActivity.forEach((act: LoginActivity) => {
      if (uniqueDevices.has(act.useragent)) {
        uniqueDevices.set(act.useragent, uniqueDevices.get(act.useragent) + 1);
      } else {
        uniqueDevices.set(act.useragent, 1);
      }
    });
    uniqueDevices.forEach((count, key) => {
      const { browser, cpu, device } = UAParser(key);
      const data = {
        browser,
        cpu,
        device,
        count,
      };
      uniqueDevicesArray.push(data);
    });
  } else {
    return <></>;
  }
  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        size={isLargerThanMd ? "xl" : "sm"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Login Activity{" for "}
            {`${
              LoginActivity && LoginActivity[0].users_permissions_user.username
            }`}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <Text fontSize="xl" fontWeight="bold"></Text>
            </Box>
            <Box mb="3">
              <Text fontSize="sm" color="gray.600"></Text>
            </Box>
            <Box>
              <Text fontSize="base" color="gray.600" fontFamily={"Lexend"}>
                Unique devices
              </Text>
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>Browser</Th>
                      <Th>Type</Th>
                      <Th>CPU</Th>
                      <Th>Count</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {uniqueDevicesArray.map((value: countTable) => {
                      console.log(value.browser);
                      return (
                        <Tr>
                          <Td>{value.browser.name}</Td>
                          <Td>{value.device.is("mobile") ? "Mobile" : "PC"}</Td>
                          <Td>{value.cpu.architecture}</Td>
                          <Td isNumeric>{value.count}</Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
            <Box mt={5}>
              <Text fontSize="base" color="gray.600" fontFamily={"Lexend"}>
                Activity Timeline
              </Text>
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>Date/Time</Th>
                      <Th>Browser</Th>
                      <Th>Type</Th>
                      <Th>CPU</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {LoginActivity.map((value: LoginActivity) => {
                      const { browser, cpu, device } = UAParser(
                        value.useragent
                      );
                      return (
                        <Tr>
                          <Td>
                            {dateFormat(
                              value.created_at,
                              "mmmm dS, yyyy, h:MM:ss TT"
                            )}
                          </Td>
                          <Td>{browser.name}</Td>
                          <Td>{device.is("mobile") ? "Mobile" : "PC"}</Td>
                          <Td>{cpu.architecture}</Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => setOpenModal(false)}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default LoginActivityModal;
